import Vue from 'vue'

Vue.filter('formatNumber', function (value, locale = 'en') {
  return new Intl.NumberFormat(locale).format(value)
})
